<template>
  <div
    v-if="loading"
    class="content"
  >
    <div class="loading">
      <div class="loader" />
    </div>
  </div>
  <div
    v-else
    class="content"
  >
    <div class="md-layout">
      <template v-for="host in site.hosts">
        <div
          :key="host.id"
          class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
        >
          <stats-card :data-background-color="host.alarmPriority">
            <template slot="header">
              <md-icon>verified_user</md-icon>
            </template>
            <template slot="content">
              <h3
                class="title"
                style="text-align: center;"
              >
                {{ host.name.substring(host.name.indexOf('_')+1,host.name.length) }}
              </h3>
            </template>
          </stats-card>
        </div>
        <template v-for="application in host.applications">
          <template v-if="application.itens.length>0">
            <template v-if="(application.id==host.applications[host.applications.length-1].id)&((host.applications.length%2) > 0)">
              <div
                :key="application.id"
                class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
              >
                <md-card>
                  <md-card-header :data-background-color="application.alarmPriority">
                    <h4 class="title">
                      {{ application.name }}
                    </h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100">
                        <md-table v-model="application.itens">
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell md-label="Atributo">
                              <a
                                v-if="item.priority>1"
                                style="color:red;"
                              >{{ item.name }}</a>
                              <a
                                v-else
                                style="color:black;"
                              > {{ item.name }}</a>
                            </md-table-cell>
                            <md-table-cell md-label="Valor">
                              <a
                                v-if="item.priority>1"
                                style="color:red;"
                              >{{ item.lastvalue }} {{ (item.units!="enum" && item.units!="bin") ? item.units : "" }}</a>
                              <a
                                v-else
                                style="color:black;"
                              > {{ item.lastvalue }} {{ (item.units!="enum" && item.units!="bin") ? item.units : "" }}</a>
                            </md-table-cell>

                            <md-table-cell md-label="Opções">
                              <router-link :to=" '/trendchart/' + item.id">
                                <i class="material-icons">insert_chart</i>
                              </router-link>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </template>
            <template v-else>
              <div
                :key="application.id"
                class="md-layout-item md-medium-size-50 md-xsmall-size-100 md-size-50"
              >
                <md-card>
                  <md-card-header :data-background-color="application.alarmPriority">
                    <h4 class="title">
                      {{ application.name }}
                    </h4>
                  </md-card-header>
                  <md-card-content>
                    <div class="md-layout">
                      <div class="md-layout-item md-medium-size-100">
                        <md-table v-model="application.itens">
                          <md-table-row
                            slot="md-table-row"
                            slot-scope="{ item }"
                          >
                            <md-table-cell md-label="Atributo">
                              <a
                                v-if="item.priority>1"
                                style="color:red;"
                              >{{ item.name }}</a>
                              <a
                                v-else
                                style="color:black;"
                              > {{ item.name }}</a>
                            </md-table-cell>
                            <md-table-cell md-label="Valor">
                              <a
                                v-if="item.priority>1"
                                style="color:red;"
                              >{{ item.lastvalue }} {{ (item.units!="enum" && item.units!="bin") ? item.units : "" }}</a>
                              <a
                                v-else
                                style="color:black;"
                              > {{ item.lastvalue }} {{ (item.units!="enum" && item.units!="bin") ? item.units : "" }}</a>
                            </md-table-cell>
                            <md-table-cell md-label="Opções">
                              <router-link :to=" '/trendchart/' + item.id">
                                <i class="material-icons">insert_chart</i>
                              </router-link>
                            </md-table-cell>
                          </md-table-row>
                        </md-table>
                      </div>
                    </div>
                  </md-card-content>
                </md-card>
              </div>
            </template>
          </template>
        </template>
      </template>
    </div>
  </div>
</template>

<script>
import {
  StatsCard,
} from "@/components";
import { userService } from "../_services";
export default {
  name: "DashboardTag",
  components: {
    StatsCard,
  },
  data() {
    return {
      loading:true,
      sites:[],
      site:[],
      alarmList: [],
      alarmListPriority: "green",
      oldList: [],
      id: null,
      old_id: null,
    };
  },
  created() {
    this.loading = true;
      this.id = this.$route.params.id;
      this.old_id=this.id;
      var i=0;
      this.sites = JSON.parse(localStorage.getItem("sites"));
      for(i=0;i<this.sites.length;i++){
        if(this.sites[i].entity==this.id){
          this.site=this.sites[i];
        }
      }
      this.loadData();
      this.timer = setInterval(this.loadData, 10000);
      this.timer = setInterval(this.checkSite, 100);
      // console.log(this.site);
  },
  beforeDestroy() {
    clearInterval(this.timer);
  },
  methods: {
    loadData: function () {



      userService.AsingZabbixUpdateItens(this.site).then(zabbixSite => {
        this.site=zabbixSite;
        // this.loading = false;
      });

      userService.AsingZabbixProblems(this.sites).then(zabbixProblems => {

        var zabbixProblemsFiltered=[];
        var highestAlarmLevel=0;
        var hostname="";
        var i=0,j=0,k=0,finalseconds=0,seconds=0, minutes=0,hours=0,days=0;
        let timestampNow = { seconds: Date.now()/ 1000, nanoseconds: 0 };

        if(this.oldList.length!=zabbixProblems.length){
          // console.log("Alarm count: "+zabbixProblems.length)
          this.site=this.site;
          this.loading = true;
        }

        // Making sure that the alarm value is new
        for(j=0;j<this.site.hosts.length;j++){
          for(k=0;k<this.site.hosts[j].applications.length;k++){
              this.site.hosts[j].applications[k].alarmPriority="green";
          }
          this.site.hosts[j].alarmPriority="green";
        }


        // Verifying all the alarms / problems
        for(i=0;i<zabbixProblems.length;i++){

          // Filtering by Site
          if(zabbixProblems[i].site == this.site.site){
            seconds = timestampNow.seconds-zabbixProblems[i].clock; // firebase data
            zabbixProblems[i].clock="";
            finalseconds = parseInt(seconds, 10) % 60;
            minutes = parseInt(seconds / 60, 10) % 60;
            hours = parseInt(seconds / 3600, 10) % 24;
            days = parseInt(seconds / 86400, 10);
            if(days>0){zabbixProblems[i].clock+=days+"d ";}
            if(hours>0){zabbixProblems[i].clock+=hours+"h ";}
            if(minutes>0){zabbixProblems[i].clock+=minutes+"m ";}
            zabbixProblems[i].clock+=finalseconds+"s";
            zabbixProblemsFiltered.push(zabbixProblems[i]);


            //Updating the alarm level
            for(j=0;j<this.site.hosts.length;j++){
              // hostname=this.site.hosts[j].name.substring(this.site.hosts[j].name.indexOf('_')+1,this.site.hosts[j].name.length);
              if(zabbixProblems[i].host == this.site.hosts[j].name){
                if(zabbixProblems[i].priority>1 && this.site.hosts[j].alarmPriority!="red" ){
                  this.site.hosts[j].alarmPriority="orange";
                }
                if(zabbixProblems[i].priority>3 ){
                  this.site.hosts[j].alarmPriority="red";
                  // console.log(this.site.hosts[j])
                  // console.log(zabbixProblems[i].priority)
                }

                for(k=0;k<this.site.hosts[j].applications.length;k++){

                    if(zabbixProblems[i].application == this.site.hosts[j].applications[k].name){
                      if(zabbixProblems[i].priority>1 && this.site.hosts[j].applications[k].alarmPriority!="red" ){
                        this.site.hosts[j].applications[k].alarmPriority="orange";
                      }
                      if(zabbixProblems[i].priority>3 ){
                        this.site.hosts[j].applications[k].alarmPriority="red";
                        // console.log(this.site.hosts[j].applications[k].name+this.site.hosts[j].name+ ":"+this.site.hosts[j].applications[k].alarmPriority);
                      }
                    }
                }

              }

            }

            // console.log(this.site);


            //Getting the maximum alarm level for alarm list identification
            if(zabbixProblems[i].priority>highestAlarmLevel){
              highestAlarmLevel=zabbixProblems[i].priority;
            }
          }

        }
        if(highestAlarmLevel>1){
          this.alarmListPriority="orange";
        }
        if(highestAlarmLevel>3){
          this.alarmListPriority="red";
        }

        this.alarmList = zabbixProblemsFiltered;
        // console.log(this.alarmList);

              // console.log(this.site);
        this.loading = false;

        this.oldList=zabbixProblems;

      });









    },
    checkSite: function () {
      this.id = this.$route.params.id;
      var i =0;
      if(this.id != this.old_id){
        this.loading = true;
        this.sites = JSON.parse(localStorage.getItem("sites"));
        for(i=0;i<this.sites.length;i++){
          if(this.sites[i].entity==this.id){
            this.site=this.sites[i];
          }
        }

        this.old_id=this.id;
        this.loadData();
        // this.loading = false;
      }
    },
    cancelAutoUpdate: function() { clearInterval(this.timer); },
  }
};
</script>
